export const customReportExportFilename = (name: string, extension: 'csv' | 'pdf'): string => {
  const slug = name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
  return `${slug || 'custom-report'}.${extension}`;
};
